import IUserInfo from '@/app/common/model/IUserInfo';
import {Nullable} from '@/app/common/util/Nullable';

export default class StorageRepository {
  private static LANG_KEY: string = 'lang';

  private static LICENSE_KEY: string = 'license';

  private static RECAPTCHA_KEY: string = 'recaptcha';
  private static USER_INFO_KEY: string = 'user';
  private static TOKEN_KEY: string = 'token';
  private static PERMISSION_KEY: string = 'permissions';

  public static getCurrentLang(): string | null {
    return localStorage.getItem(this.LANG_KEY);
  }

  static setCurrentLang(currentLang: string) {
    localStorage.setItem(this.LANG_KEY, currentLang);
  }

  static saveLicense(license: string | null) {
    if (license) {
      localStorage.setItem(this.LICENSE_KEY, license);
    }
  }

  static saveRecaptcha(reCaptcha: string | null) {
    if (reCaptcha) {
      localStorage.setItem(this.RECAPTCHA_KEY, reCaptcha);
    }
  }

  public static getRecaptcha(): string | null {
    return localStorage.getItem(this.RECAPTCHA_KEY);
  }

  public static getLicense(): string | null {
    return localStorage.getItem(this.LICENSE_KEY);
  }

  static isLicenseAndRecaptchaCached(): boolean {
    return !!this.getLicense() || !!this.getRecaptcha();
  }

  static async saveUserInfo(userInfo: IUserInfo): Promise<IUserInfo> {
    localStorage.setItem(this.USER_INFO_KEY, JSON.stringify(userInfo));
    localStorage.setItem(this.TOKEN_KEY, userInfo.token);
    return Promise.resolve(userInfo);
  }

  public static getUserInfo(): Nullable<IUserInfo> {
    const userInfo: Nullable<string> = localStorage.getItem(this.USER_INFO_KEY);
    if (userInfo) {
      return JSON.parse(userInfo);
    }
    return null;
  }

  public static getToken(): Nullable<string> {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  static clearCredentials() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_INFO_KEY);
    localStorage.removeItem(this.PERMISSION_KEY);
  }

  static savePermissions(permissionList: string[]) {
    localStorage.setItem(this.PERMISSION_KEY, JSON.stringify(permissionList));
  }
}
